import { ReactElement } from 'react';
import { Typography } from 'antd';

const { Paragraph } = Typography;

interface Props {
  content: string;
}

const SummaryDisplay = ({ content }: Props): ReactElement => {
  return <Paragraph style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{content}</Paragraph>;
};

export default SummaryDisplay;
